function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.01184 1.85843L8.11483 2.46701V2.65188C7.02602 2.6024 5.93717 2.59241 4.8495 2.63561L4.87324 2.49095L4.97817 1.85137C5.02148 1.58877 5.05692 1.43762 5.14368 1.33072C5.20272 1.25798 5.35469 1.125 5.83983 1.125H7.14983C7.63093 1.125 7.78507 1.26141 7.8468 1.33894C7.93632 1.45137 7.97078 1.6066 8.01135 1.85546L8.01134 1.85546L8.01184 1.85843ZM2.01362 3.11261C2.01337 3.11264 2.01311 3.11266 2.01286 3.11269L2.01362 3.11261Z",
    fill: "#B42318",
    stroke: "#B42318",
    style: {
      fill: "#B42318",
      fill: "color(display-p3 0.7059 0.1373 0.0941)",
      fillOpacity: 1,
      stroke: "#B42318",
      stroke: "color(display-p3 0.7059 0.1373 0.0941)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65987 4.375C9.69145 4.375 9.72471 4.38768 9.75047 4.41255C9.77427 4.4404 9.78765 4.47725 9.78569 4.51644C9.78567 4.51672 9.78566 4.51699 9.78564 4.51726L9.47596 9.63698C9.44641 10.0471 9.41304 10.321 9.26992 10.5169C9.15818 10.6698 8.89215 10.88 8.10487 10.88H4.89487C4.10853 10.88 3.84221 10.6691 3.7301 10.5154C3.5866 10.3186 3.55333 10.0442 3.52378 9.63685L3.21406 4.51148C3.21405 4.51131 3.21404 4.51115 3.21403 4.51098C3.21226 4.47729 3.22533 4.43843 3.25284 4.40853C3.26709 4.39304 3.30049 4.375 3.33987 4.375H9.65987ZM5.66487 9.375H7.32987C7.81102 9.375 8.20487 8.98114 8.20487 8.5C8.20487 8.01886 7.81102 7.625 7.32987 7.625H5.66487C5.18373 7.625 4.78987 8.01886 4.78987 8.5C4.78987 8.98114 5.18373 9.375 5.66487 9.375ZM5.24987 7.375H7.74987C8.23102 7.375 8.62487 6.98114 8.62487 6.5C8.62487 6.01886 8.23102 5.625 7.74987 5.625H5.24987C4.76873 5.625 4.37487 6.01886 4.37487 6.5C4.37487 6.98114 4.76873 7.375 5.24987 7.375Z",
    fill: "#B42318",
    stroke: "#B42318",
    style: {
      fill: "#B42318",
      fill: "color(display-p3 0.7059 0.1373 0.0941)",
      fillOpacity: 1,
      stroke: "#B42318",
      stroke: "color(display-p3 0.7059 0.1373 0.0941)",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashQuestion);
export default __webpack_public_path__ + "static/media/trash-question.c5251732f5b1fc49a6a8e0f779e0c4cd.svg";
export { ForwardRef as ReactComponent };